__turbopack_context__.v({
  "Active": "Categories-module-sass-module__d6miIW__Active",
  "Categories": "Categories-module-sass-module__d6miIW__Categories",
  "Category": "Categories-module-sass-module__d6miIW__Category",
});
